import { Component, OnInit } from '@angular/core';
import { UsersService, AdminRole } from '../services/users.service'
import { Router} from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

  constructor(private authService:UsersService, private router: Router) { }

  public disabled:boolean = false;
  public status:{isopen:boolean} = {isopen: false};
  public version:string = environment.version
  
  public toggled(open:boolean):void {
    console.log('Dropdown is now: ', open);
  }

  public toggleDropdown($event:MouseEvent):void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  ngOnInit(): void {}

  currentUser() {
    return this.authService.currentUser
  }

  onSignOut() {
    this.authService.signOut()
    this.router.navigate(['/sigin'])
  }

  isBrandAdmin() {
    return this.authService.currentUser.role == AdminRole[AdminRole.SuperAdmin] ||
           this.authService.currentUser.role == AdminRole[AdminRole.BrandAdmin]
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/full-layout.component.ts